import $ from 'jquery';

const readyCallbacks = $.Callbacks('unique');
const unloadCallbacks = $.Callbacks('unique');

window.addElementReadyCallback = function(callback) {
    readyCallbacks.add(callback);
    callback.call(document);
};

window.addElementUnloadCallback = function(callback) {
    unloadCallbacks.add(callback);
};

$.fn.elementReady = function() {
    readyCallbacks.fireWith(this);

    return this;
};

$.fn.elementUnload = function() {
    unloadCallbacks.fireWith(this);

    return this;
}
